/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcRotateCcwRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M6.153 8.815a7.1 7.1 0 1 1-.475 5.158.9.9 0 0 0-1.73.499A8.9 8.9 0 1 0 4.9 7.367V5.143a.9.9 0 0 0-1.8 0v4.572a.9.9 0 0 0 .9.9h4.57a.9.9 0 0 0 0-1.8z" />
    </svg>
  );
}
export default IcRotateCcwRegular;
